import { Inject, Injectable, Injector } from "@angular/core";
import { BaseApi } from "../base-api";
import { HttpClient } from "@angular/common/http";
import { APP_CONFIGURATION } from "../../../../../core/src/lib/core.di";
import { AppConfig } from "../../../../../core/src/lib/app-config/config.types";
import { map, Observable } from "rxjs";
import { ApiResponseDTO } from "../common.types";
import { TransferProfileRequest, TransferProfileResponseDTO, UserShortInfoDTO } from "./user-bridge.types";

@Injectable({ providedIn: "root" })
export class UserBridgeApi extends BaseApi {
  private basePath: string;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly injector: Injector,
    @Inject(APP_CONFIGURATION) readonly appConfig: AppConfig,
  ) {
    super(injector);
    this.basePath = appConfig.apiEndpointUrl;
  }

  getUserShortInfo(authToken: string): Observable<UserShortInfoDTO> {
    return this.httpClient
      .get<ApiResponseDTO>(`${this.basePath}/user-bridge/destination/user-short-info/${authToken}`)
      .pipe(
        map((response) => {
          if (response.success) {
            return response.results.info;
          } else {
            super.handleErrorResponse(response);
            throw new Error("Failed to get user short info");
          }
        }),
      );
  }

  transferProfile(token: string, request: TransferProfileRequest): Observable<TransferProfileResponseDTO> {
    return this.httpClient
      .post<ApiResponseDTO>(`${this.basePath}/user-bridge/destination/transfer-profile/${token}`, request)
      .pipe(
        map((response) => {
          if (response.success) {
            return response.results.reply;
          } else {
            super.handleErrorResponse(response);
            throw new Error("Failed to transfer profile");
          }
        }),
      );
  }
}
